export default __webpack_public_path__ + "static/media/screen_google_calendar_05.34eb8283.png";